import * as React from 'react';
import * as moment from 'moment';

import { IWACEvent } from '../classes/event';
import Image from '../components/image';
import ListEventView from '../views/list-row';
import { IDay } from '@adage/calendar/services/calendar';

interface ListViewEventProps {
    day: IDay<IWACEvent>;
}

class ListEvent extends React.Component<ListViewEventProps, null> {

    render() {
        return <ListEventView day={this.props.day} />
    }
}

export default ListEvent;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/components/list-row.tsx